module.exports = __webpack_public_path__ + "img/ic_back_active.067172d3.svg";